/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {createSlice} from '@reduxjs/toolkit'

const userSlice = createSlice({
  name: 'user',
  initialState: {
    selectedStudent: null,
  },
  reducers: {
    setSelectedStudent: (state, action) => {
      state.selectedStudent = action.payload.selectedStudent
    },
  },
})

export const {setSelectedStudent} = userSlice.actions

export default userSlice.reducer
